// @flow

import React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

type Props = {
  children?: any,
};

const Wrapper = styled.ul`
  display: flex;
  flex-flow: column;

  ${breakpoint('tablet')`
    flex-flow: row;
    flex-wrap: wrap;
  `};
`;

const Filters = ({ children }: Props) => <Wrapper>{children}</Wrapper>;

export default Filters;
